/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PatientQuestionsModalAliases {
  FORM = 'form',
  LAYOUT_TITLE = 'layout-title',
  LOADER_0 = 'loader-0',
  PANEL_0 = 'panel-0',
  PATIENT_QUESTIONS_LAYOUT = 'patient-questions-layout',
  QUESTION_1 = 'question-1',
  QUESTION_01_TEXT_AREA = 'question-01-text-area',
  QUESTION_2 = 'question-2',
  QUESTION_02_TEXT_AREA = 'question-02-text-area',
  QUESTION_3 = 'question-3',
  QUESTION_03_TEXT_AREA = 'question-03-text-area',
  TITLE_PANEL = 'title-panel',
  TITLE_TEXT = 'title-text',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { PatientQuestionsModalAliases };
